module.exports = __webpack_public_path__ + "static/img/bg.9e4c9f5c.jpg";